import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import copy from 'fast-copy';
import { Contendiente } from 'src/app/interfaces/contendiente.interface';
import { ContendientesService } from 'src/app/services/contendientes.service';
import {MatDialog} from '@angular/material/dialog';
import { AvisoComponent } from '../aviso/aviso.component';
import { VisorComponent } from '../visor/visor.component';

@Component({
  selector: 'app-renuncias',
  templateUrl: './renuncias.component.html',
  styleUrls: ['./renuncias.component.css'],
})
export class RenunciasComponent implements OnInit {
  title = 'Diputados 2023-2024';
  idioma = 'es';
  loading: boolean = false;
  allcontendientes: Contendiente[] = [];
  contendientes: Contendiente[] = [];
  contendiente: any;
  fullTextString: any;
  keyWord: any;
  loadingPosts: boolean = true;
  files: any;
  catalog: any;
  error: any;
  toDay: Date = new Date();
  hoy = this.toDay.setDate(this.toDay.getDate());
  showDelay = new FormControl(500);
  hideDelay = new FormControl(1500);
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;

  private dialogRef: any;
  formulario: FormGroup = this.formBuilder.group({
    nombre: ['', [Validators.maxLength(50)]],
  });

  constructor(
    private formBuilder: FormBuilder,private api: ContendientesService,public dialog: MatDialog) {}

  ngOnInit(): void {
    this.loading = true;
    this.api.getContendientesRenuncia(false).subscribe((data) => {
      this.allcontendientes = data;

      this.allcontendientes.forEach((element: Contendiente) => {
        const myData = copy(element);
        myData.Tipo = myData.NombreArchivo
          ? myData.NombreArchivo.split('.')[1]
          : myData.NombreArchivo;
        element = myData;
        // console.log(element);
      });
      this.contendientes = this.allcontendientes;
      this.loading = false;
    });
let mostrarDialog=false;
    if(mostrarDialog)
        this.openDialog();
  }
  openDialog() {
    const dialogRef = this.dialog.open(AvisoComponent, {
      width: '95%',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  sumarDias(fecha: any, dias: number) {
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  campoNoEsValido(campo: string) {
    return (
      this.formulario.controls[campo].touched &&
      this.formulario.controls[campo].invalid
    );
  }

  get procendenciaMSG(): string {
    const errorsMsg = this.formulario.get('nombre')?.errors;
    if (errorsMsg?.['minlength']) return 'El mínimo de caracteres es de 3';
    if (errorsMsg?.['maxlength']) return 'El máximo de caracteres es de 70';
    return '';
  }

  buscarContendientes() {
    let termino = this.formulario.get('nombre')?.value;
    if (termino == '') this.contendientes = this.allcontendientes;
    else {
      const formatVal = termino
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');
      this.contendientes = this.allcontendientes.filter(
        (a: any) =>
          a.NombreDiputado != null &&
          a.NombreDiputado.toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .includes(formatVal)
      );
    }
  }

  limpiarFormulario() {
    this.formulario.setValue({
      nombre: '',
    });
    this.buscarContendientes();
  }
  
  VerCarta(Oid:String){
    this.dialogRef = this.dialog.open(VisorComponent, {
      width: '70%',
      height: '80%',
      data: { tipo:2,oid:Oid }
    });
    this.dialogRef.afterClosed().subscribe((result:any) => {
      // console.log('::::::::::Modal closed! :' + result);
    });
  }

  downloadBase64File(objeto: Contendiente) {
    // console.log(objeto);
    this.api.getContendiente(false, objeto.Oid).subscribe((data) => {
      // console.log(data);
      this.contendiente = null;
      if (data[0] !== undefined) {
        this.contendiente = data[0];
        const myData = copy(this.contendiente);
        myData.Tipo = myData.NombreArchivo
          ? myData.NombreArchivo.split('.')[1]
          : myData.NombreArchivo;
        this.contendiente = myData;
        let base64: any = null;
        let fileName: any = null;
        let fileType: any = null;
        if (this.contendiente) {
          base64 = this.contendiente.ArchivoB642;
          fileName = this.contendiente.NombreArchivo;
          // console.log({ base64 });
          fileType = this.contendiente.Tipo;
          // console.log({ fileType });
          // console.log({ fileName });
        }
        const linkSource = `data:application/jpg;base64,${base64}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = 'archivo.jpg';
        downloadLink.click();
        downloadLink.remove();
      }
      this.loading = false;
    });
  }
}
